<script>
  import { onMount, getContext } from 'svelte';
  import { page } from '$app/stores';
  import Text from '@components/Text.svelte';
  import Notification from '@utils/notification';
  import ScrollSpy from '@utils/scrollspy';
  import ComponentEvents from '@utils/component-events';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recsStore = getGroupStore('recsStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let configStore = getGroupStore('configStore');
  import SectionAjax from '@ajax/section';
  import RecObjectAjax from '@ajax/rec_object';
  import { sortBy } from 'lodash-es';
  import { resizeEnd } from '@utils/browser-utils';
  import { isWholeRowSingleLineOnly, getRecObjectIdsForSection } from '@app-components-helper/group/section';
  import CustomScroll from '@utils/custom-scroll';

  import RemoveSectionModal from '@app-components/modal/RemoveSectionModal.svelte';
  import RecObject from '@app-components/RecObject.svelte';
  import Sortable from 'sortablejs';
  const AutoScroll = Sortable.AutoScroll;
  import { browser } from '$app/environment';
  try {
    Sortable.mount(new AutoScroll());
  } catch {}

  export let lastSection = false;

  import jQuery from 'jquery';

  export let id;
  let group = groupStore;
  let section = sectionsStore.find(id);
  let recs = [];
  let recObjects = [];
  let recObjectIds = [];
  let showRemoveModal = false;
  let recObjectSingleLineNames = {};

  let sectionEl;
  let allGroupRecsLoadedStore = getContext('allGroupRecsLoadedStore');

  let sortByOrder = function (instance, orderIds) {
    return sortBy(instance, (x) => {
      var idx = orderIds.indexOf(x);
      if (idx == -1) {
        idx = 9999;
      }
      return idx;
    });
  };

  let computeRecObjectIdsFromRecs = function (recs) {
    let tempIds = [...new Set(recs.map((r) => r.rec_object_id))]; // unique ids
    let sortOrder = [...(section ? section.sort_order : []), ...group.rec_objects_sort_order].map((x) => parseInt(x));
    tempIds = sortByOrder(tempIds, sortOrder);
    recObjectIds = tempIds;
  };

  let updateRecObjectHeightsTimeout;

  const updateRecObjectHeights = () => {
    // The setTimeout here allows the DOM to render after updates, which needs to be checked
    // in order to compute correctly.
    if (updateRecObjectHeightsTimeout) {
      return;
    }

    updateRecObjectHeightsTimeout = setTimeout(() => {
      updateRecObjectHeightsTimeout = undefined;
      var ids = getRecObjectIdsForSection(sectionEl);

      recObjects.forEach((recObject) => {
        const wholeRowSingleLineOnly = isWholeRowSingleLineOnly(
          recObject,
          recObjectsStore,
          ids.length > 0 ? ids : recObjectIds,
          configStore,
          groupStore
        );

        recObjectSingleLineNames = {
          ...recObjectSingleLineNames,
          [recObject.id]: wholeRowSingleLineOnly,
        };
      });
    }, 50);
  };

  let updateSection = async function (data) {
    try {
      section.set(await SectionAjax.update(group, section, data));
      sectionsStore.runCallbacks();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
        section = section;
      }
    }
  };

  let attachScrollSpy = function (node) {
    if (!node || !section) {
      return;
    }

    ScrollSpy.addElementForKey(
      node,
      'grid-current-section',
      {
        section: section,
      },
      section.id
    );
  };

  let checkIntersectsSectionBar = function (evt) {
    var selectedSection;

    jQuery('.grid-section-category').each(function () {
      var elem = jQuery(this);
      var top = elem.offset().top - jQuery(window).scrollTop();
      var left = elem.offset().left;
      var height = elem.outerHeight(true);
      var width = elem.outerWidth(true);
      var x = evt.originalEvent.clientX;
      var y = evt.originalEvent.clientY;
      if (y >= top && y <= top + height && x >= left && x <= left + width) {
        selectedSection = elem;
        return;
      }
    });
    return selectedSection;
  };

  let sortOrderWithSectionsFromPage = function () {
    let sectionData = [];

    jQuery('[data-section-id]').each(function () {
      let localRecObjectIds = [];
      let recIds = [];
      let id = jQuery(this).data('section-id');

      jQuery(this)
        .find('[data-rec-object-id]')
        .each(function () {
          var recObjectId = jQuery(this).data('rec-object-id');
          localRecObjectIds.push(recObjectId);
        });

      jQuery(this)
        .find('[data-rec-id]')
        .each(function () {
          var recId = jQuery(this).data('rec-id');
          recIds.push(recId);
        });

      sectionData.push({
        id: id,
        rec_object_ids: localRecObjectIds,
        rec_ids: recIds,
      });
    });

    return sectionData;
  };

  let updateSortOrder = function (evt) {
    let sortOrder = sortOrderWithSectionsFromPage();
    RecObjectAjax.updateSortOrder(group, sortOrder);

    let newSectionId = jQuery(evt.item).closest('[data-section-id]').data('section-id');

    let recIds = jQuery(evt.item)
      .find('[data-rec-id]')
      .map(function () {
        return jQuery(this).data('rec-id');
      })
      .get();

    let runCallbacksForRecs = false;

    recIds.forEach((rid) => {
      let rec = recsStore.find(rid);
      if (rec.section_id != newSectionId) {
        runCallbacksForRecs = true;
        rec.set({ ...rec, section_id: newSectionId });
      }
    });

    sortOrder.forEach((data) => {
      let s = sectionsStore.find(data.id);
      if (s) {
        s.set({ ...s, sort_order: data.rec_object_ids });
      }
    });

    if (runCallbacksForRecs) {
      // only call when section changed
      recsStore.runCallbacks();
    }

    computeRecObjectIdsFromRecs(recs);
    ComponentEvents.trigger('refresh-broken-owl');
  };

  let moveRecToSection = async function (newSectionId, evt) {
    let recObjectId = jQuery(evt.item).find('[data-rec-object-id]').data('rec-object-id');

    let recIds = jQuery(evt.item)
      .find('[data-rec-id]')
      .map(function () {
        return jQuery(this).data('rec-id');
      })
      .get();

    recIds.forEach((id) => {
      let rec = recsStore.find(id);
      rec.set({ ...rec, section_id: newSectionId });
    });

    let localRecObjectIds = [];

    jQuery(`div[data-section-id='${newSectionId}']`)
      .find('[data-rec-object-id]')
      .each(function () {
        var recObjectId = jQuery(this).data('rec-object-id');
        localRecObjectIds.push(recObjectId);
      });

    recsStore.runCallbacks();
    ComponentEvents.trigger('refresh-broken-owl');

    await RecObjectAjax.moveToSection(
      group,
      { id: recObjectId },
      {
        section_id: newSectionId,
        rec_ids: recIds,
        rec_object_ids: localRecObjectIds,
      }
    );

    let sortOrder = sortOrderWithSectionsFromPage();
    RecObjectAjax.updateSortOrder(group, sortOrder);
  };

  let draggable = function (node) {
    if (browser && group.permissions.edit) {
      let browserHeight = jQuery(window).height();
      let topBarHeight = jQuery('.grid-sections-bar').outerHeight();
      let speedUpPixels = 40;
      let speedUpMultiplier = 3;
      let dragStartTime;

      new Sortable(node, {
        group: {
          name: 'recobjects',
        },
        forceFallback: true,
        fallbackOnBody: true,
        fallbackTolerance: 2,
        handle: '.rec-object-grid-view',
        scroll: true,
        scrollSensitivity: topBarHeight + 50,
        scrollSpeed: 20,
        scrollFn: function (x, y, evt, touchEvt, el) {
          topBarHeight = jQuery('.grid-sections-bar').outerHeight() + jQuery('.group-header-sticky').outerHeight();
          var bottomY = browserHeight - evt.y;

          if (evt.y > speedUpPixels && evt.y < topBarHeight) {
            return;
          }
          if (bottomY < topBarHeight + 50 && bottomY > 120) {
            return;
          }
          if (evt.y <= speedUpPixels || bottomY <= speedUpPixels) {
            y = y * speedUpMultiplier;
          }
          el.scrollTop += y;
        },
        filter: '.undraggable',
        preventOnFilter: false,
        onStart: (evt) => {
          dragStartTime = new Date();
          var item = jQuery(evt.item);
          item.find('.grid-ro-draggable-placeholder').show();
          item.find('.rec-object-grid-view').hide();
          item.find('.comments-box').css('opacity', 0);

          ComponentEvents.trigger('section-bar-disable-scroll-updates', {
            shown: true,
            showAll: 'ifNotSticky',
            recObjectSorting: true,
          });
        },
        onAdd: (evt) => {
          var intersectedSection = checkIntersectsSectionBar(evt);
          if (!intersectedSection) {
            updateSortOrder(evt);
          }
        },
        onUpdate: (evt) => {
          var intersectedSection = checkIntersectsSectionBar(evt);
          if (!intersectedSection) {
            updateSortOrder(evt);
          }
        },
        onEnd: (evt) => {
          let item = jQuery(evt.item);
          item.find('.rec-object-grid-view').show();
          item.find('.grid-ro-draggable-placeholder').hide();
          item.find('.comments-box').css('opacity', 1);

          ComponentEvents.trigger('section-bar-enable-scroll-updates', {
            shown: false,
            showAll: false,
            recObjectSorting: false,
          });

          if (new Date() - dragStartTime < 60) {
            return;
          }

          let intersectedSection = checkIntersectsSectionBar(evt);

          if (intersectedSection) {
            var movedSectionId = intersectedSection.parent().data('section-bar-section-id');

            moveRecToSection(movedSectionId, evt);
          }
        },
      });
    }
  };

  let updateRecObjects = function () {
    recObjects = recObjectsStore.filter((recObject) => recObjectIds.includes(recObject.id));
  };

  let setRecAndRecObjects = function (newRecsStore) {
    if (section) {
      recs = newRecsStore.where({ section_id: section.id });
    } else {
      recs = newRecsStore;
    }
    computeRecObjectIdsFromRecs(recs);
    updateRecObjects();
  };

  setRecAndRecObjects(recsStore);
  let recObjectContainer;

  onMount(() => {
    resizeEnd(() => updateRecObjectHeights());
    let groupUnsub = groupStore.subscribe((x) => (group = x));

    let sectionUnsub =
      section &&
      section.subscribe((x) => {
        section = x;
        updateRecObjectHeights();
      });

    let recsUnsub = recsStore.subscribe((x) => {
      setRecAndRecObjects(x);
    });

    let recObjectsUnsub = recObjectsStore.subscribe(() => {
      updateRecObjects();
      updateRecObjectHeights();
    });

    CustomScroll.loadRequestedSection($page, 'grid-section-');
    draggable(recObjectContainer);

    return () => {
      groupUnsub();
      recsUnsub();
      recObjectsUnsub();
      if (sectionUnsub) {
        sectionUnsub();
      }
    };
  });
</script>

<style style="text/scss" lang="scss">
  .grid-section {
    margin-bottom: 88px;

    .ui-section-description {
      margin-top: 24px;
      font-size: 15px;
      line-height: 25px;
      text-align: center;
      color: #7f7f7f;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }

    .grid-section-header-container {
      display: flex;
      align-items: center;
      justify-content: center;

      .grid-section-header {
        font-weight: 500;
        font-size: 34px;
        line-height: 46px;
        display: flex;
        position: relative;
        margin-left: 56px;
        max-width: 600px;

        .ui-actions {
          z-index: 4;
          opacity: 0;
          position: absolute;
          padding: 20px 10px 10px 10px;
          border: none;
          display: flex;
          gap: 5px;
          background: transparent;
          transition: all 0.25s !important;
          right: 100%;
          margin-top: -22px;

          .remove-btn {
            background: #f3f1f9;
            border-color: #f3f1f9;
            transition: 0.25s;
            width: 52px;
            height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-bottom: 0px;

            &:hover {
              background: #ff5567;
              border-color: #ff5567;
              svg {
                fill: white;
              }
            }
          }

          .copy-link:hover {
            cursor: pointer;
          }

          .copy-link {
            background: #f3f1f9;
            border-color: #f3f1f9;
            transition: 0.25s;
            width: 52px;
            height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-bottom: 0px;

            &:hover {
              border-color: #a893f9;
              background: #a893f9;

              svg {
                stroke: white;
                fill: white;
              }
            }
          }
        }

        &:hover {
          .ui-actions {
            opacity: 1;
          }
        }
      }

      .items-count {
        font-size: 17px;
        line-height: 24px;
        opacity: 0.5;
        margin-top: 4px;
      }
    }

    .grid-rec-objects-container {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: 30px;

      .grid-rec-object-container {
        flex-shrink: 0;
        margin-top: 20px;
        margin-right: 20px;

        &:nth-child(3n) {
          margin-right: 0px;
        }
      }
    }
  }

  @media only screen and (max-width: 1374px) {
    .grid-rec-objects-container {
      max-width: 780px;
      margin-left: auto;
      margin-right: auto;

      .grid-rec-object-container {
        &:nth-child(3n) {
          margin-right: 20px !important;
        }

        &:nth-child(2n) {
          margin-right: 0px !important;
        }
      }
    }
  }

  .grid-ro-draggable-placeholder {
    border: 2px dashed #ccc;
    background: #f9f7ff;
    opacity: 0.5;
    height: 522px;
    width: 380px;
    border-radius: 15px;
    display: none;
  }

  .center-rec-objects {
    justify-content: center;
  }

  :global(.group-section-desktop-h2) {
    font-weight: 500;
    font-size: 34px;
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 46px;
    overflow: hidden;
  }
</style>

{#if group && group.permissions && group.permissions.edit}
  {#if showRemoveModal}
    <RemoveSectionModal bind:showModal={showRemoveModal} section={section} />
  {/if}
{/if}

<div class="grid-section" use:attachScrollSpy bind:this={sectionEl}>
  {#if section}
    <div class="grid-section-header-container" id="grid-section-{section.id}">
      <div class="grid-section-header">
        <div class="ui-actions undraggable">
          {#if group && group.permissions && group.permissions.edit}
            <button
              class="remove-btn"
              on:click|preventDefault|stopPropagation={() => {
                showRemoveModal = true;
              }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="#ff5567" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10 0C10.5523 0 11 0.447715 11 1C11 1.55228 11.4477 2 12
                  2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15
                  4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1
                  2H4C4.55228 2 5 1.55228 5 1C5 0.447715 5.44772 0 6
                  0H10ZM3.21365 15.4616C2.84389 15.1173 2.61761 14.6462 2.58002
                  14.1423L2.02721 6.40427C1.98586 5.82539 2.44433 5.33301
                  3.02467 5.33301H12.9754C13.5557 5.33301 14.0142 5.82539
                  13.9728 6.40426L13.42 14.1423C13.3824 14.6462 13.1561 15.1173
                  12.7864 15.4616C12.4166 15.8059 11.9306 15.9981 11.4254
                  15.9997H4.57468C4.06944 15.9981 3.58341 15.8059 3.21365
                  15.4616Z" />
              </svg>
            </button>
          {/if}

          <button
            id="copy-link-{section.id}"
            class="copy-link"
            on:click={() => {
              CustomScroll.copySectionLink($page, section.id);
            }}>
            <svg
              fill="#a893f9"
              height="16"
              viewBox="0 0 24 24"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <mask id="a" height="24" maskUnits="userSpaceOnUse" width="24" x="0" y="0"
                ><path d="m0 0h24v24h-24z" fill="#fff" /></mask>
              <g mask="url(#a)">
                <path
                  d="m3.10926 3.10926c.28339-.28339.66775-.44259 1.06852-.44259h5.53333c.73639 0 1.33329-.59696
                1.33329-1.33334 0-.736376-.5969-1.33333-1.33329-1.33333h-5.53333c-1.10802 0-2.17065.440157-2.95414
                1.22364-.783483.78349-1.22364 1.84612-1.22364 2.95414v15.64442c0 1.108.440157 2.1707 1.22364
                2.9542.78349.7834 1.84612 1.2236 2.95414 1.2236h15.64442c1.108 0 2.1707-.4402 2.9542-1.2236.7834-.7835
                1.2236-1.8462 1.2236-2.9542v-5.5333c0-.7364-.597-1.3333-1.3333-1.3333-.7364 0-1.3334.5969-1.3334
                1.3333v5.5333c0 .4008-.1592.7851-.4426 1.0685s-.6677.4426-1.0685.4426h-15.64442c-.40077
                0-.78513-.1592-1.06852-.4426s-.44259-.6677-.44259-1.0685v-15.64442c0-.40077.1592-.78513.44259-1.06852z" />
                <path
                  d="m15.3872 1.63022 8.3476
                6.14694c.0812.05046.1482.12027.1945.20294.0464.08268.0707.17552.0707.2699s-.0243.18722-.0707.2699c-.0463.08267-.1133.15248-.1945.20294l-8.3476
                6.14696c-.3531.26-.6421.1182-.6421-.3152v-3.9404c-1.458.0053-2.8981.3159-4.2241.9112-1.32596.5952-2.50736 1.4613-3.46528
                2.5406-.04973.0566-.11133.1021-.18058.1333-.06926.0311-.14456.0473-.22074.0473-.07619
                0-.15148-.0162-.22074-.0473-.06926-.0312-.13086-.0767-.18059-.1333-.117-.1238-.19749-.2764-.23284-.4416s-.02422-.3368.03218-.4963c1.42872-4.25552
                4.67949-7.24231 8.69269-7.24231v-3.94035c0-.43343.289-.57529.6421-.31522z" />
              </g>
            </svg>
          </button>
        </div>

        <Text
          style="padding-left: 14px; padding-right: 14px; width: auto; text-align: center;"
          text={group.permissions.edit ? section.name : `<h2 class="group-section-desktop-h2">${section.name}</h2>`}
          lines={4}
          editable={group.permissions.edit}
          on:blur={(e) => {
            updateSection({ name: e.detail.text });
          }} />
      </div>
      <div>
        <img
          src="/emojis/purple_star.png"
          style="width: 22px; height: 22px; margin-left: 14px; margin-right:
          12px; margin-top: 4px;" />
      </div>
      <div class="items-count">
        {#if $allGroupRecsLoadedStore}{recObjectIds.length}{/if}
      </div>
    </div>

    {#if section.description || group.permissions.edit}
      <div class="ui-section-description">
        <Text
          style="width: 100% !important; text-align: center;"
          placeholder="Add description"
          lines={2}
          expand={true}
          text={section.description}
          editable={group.permissions.edit}
          editor={true}
          on:file-upload-complete={(e) => {
            updateSection({ description: e.detail.text });
          }}
          on:blur={(e) => {
            updateSection({ description: e.detail.text });
          }} />
      </div>
    {/if}
  {/if}

  <div
    style={lastSection ? 'min-height: 300px' : ''}
    class="grid-rec-objects-container"
    class:center-rec-objects={recObjectIds.length <= 1}
    bind:this={recObjectContainer}
    data-section-id={(section && section.id) || ''}>
    {#each recObjectIds as recObjectId (recObjectId)}
      <div class="grid-rec-object-container">
        <div class="grid-ro-draggable-placeholder">&nbsp;</div>

        <RecObject
          id={recObjectId}
          sectionId={section && section.id}
          group={group}
          singleLineNameOnly={recObjectSingleLineNames[recObjectId]}
          showOnRender={!browser}
          on:rec-object-changed={updateRecObjectHeights}
          on:rec-object-fully-rendered={() => {
            ComponentEvents.trigger('group-rec-object-rendered', recObjectId);
            updateRecObjectHeights();
          }} />
      </div>
    {/each}
  </div>
</div>
